import { withTranslation } from "next-i18next";
import { memo } from 'react';
import { Button } from "@components/core";

const CatalogFiltersFooter = memo(function CatalogFiltersFooter({
  clearFiltersAndClose,
  closeSectionAndFilters,
  resultsCount,
  t,
}) {
  return (
    <div className="catalog-filters-footer">
      <div className="py-2">
        <p className="mb-0 text-center font-size-sm text-gray">
          {t("catalog:filters.results", { count: resultsCount || 0 })}
        </p>
      </div>
      <div className="bg-white d-flex flex-column gap-2 p-3">
        <Button
          fullWidth
          onClick={() => {
            closeSectionAndFilters();
          }}
        >
          {t("catalog:filters.apply")}
        </Button>
        <Button
          variant="ghost-primary"
          fullWidth
          onClick={clearFiltersAndClose}
        >
          {t("catalog:filters.delete")}
        </Button>
      </div>
    </div>
  );
});

export default withTranslation("catalog")(CatalogFiltersFooter);
